import { RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ParamsRouterState } from './router-serializer';

export const selectRouterState = createFeatureSelector<RouterReducerState<ParamsRouterState>>(
  'router',
);

export const selectRouterQueryParams = createSelector(selectRouterState, (state) => {
  if (!!state) {
    return state.state.queryParams;
  }
  return;
});

export const selectRouterQueryParamPriceBy = createSelector(selectRouterState, (state) => {
  if (!!state) {
    return state.state.queryParams.priceBy;
  }
  return;
});

export const selectOrderByQueryParam = createSelector(selectRouterState, (state) => {
  if (!!state) {
    const { sortBy, sortCriteria } = state.state.queryParams;
    return {
      sortBy,
      sortCriteria,
    };
  }
  return;
});

export const selectRouterEntity = createSelector(selectRouterState, (state) => {
  if (!!state) {
    return state.state.entity;
  }
  return;
});

export const selectQuery = createSelector(
  selectRouterQueryParams,
  selectRouterEntity,
  (queryParams, entity) => {
    if (!!entity || !!queryParams) {
      return {
        entity,
        queryParams,
      };
    }
    return;
  },
);

export const selectSearchBoxParams = createSelector(
  selectRouterQueryParams,
  selectRouterEntity,
  (queryParams, entity) => {
    if (!!entity || !!queryParams) {
      const { date, rooms, type, currencyCode } = queryParams;
      return {
        currencyCode,
        date,
        entity,
        rooms,
        type,
      };
    }
    return;
  },
);

export const selectTrivagoReference = createSelector(selectRouterQueryParams, (queryParams) => {
  if (!!queryParams && queryParams.trv_reference && queryParams.trv_reference !== undefined) {
    return queryParams.trv_reference;
  }
});
